export const bankInfoUrl = {
  root: (buyerId: number) => `/buyers/${buyerId}/bank-info`,
  // 바이어 기본 입금자명(패스픽 주문·멤버십 신청에 마지막으로 적은 값)
  remitterName: (buyerId: number) => `/buyers/${buyerId}/remitter-name`,
};
